import React, { Component, useState } from 'react';

import AboutSummary from './AboutSummary.js';
import Intro from './Intro.js';
import Background from './Background.js';
import Education from './Education.js';
import Mission from './Mission.js';
import Philosophy from './Philosophy.js';

class Content extends Component {
    render (){
        const { activeButton } = this.props;
          return ( 
            <div className="about-right-section">
                <div className="about-wrapper">
                    <AboutSummary activeButton={activeButton}></AboutSummary>
                    <Intro activeButton={activeButton}></Intro>
                    <Background activeButton={activeButton}></Background>
                    <Education activeButton={activeButton}></Education>
                    <Mission activeButton={activeButton}></Mission >
                    <Philosophy activeButton={activeButton}></Philosophy>
                </div>
            </div>
          )
    }
}

export default Content;